import { Translate, useTranslate } from '@spazious/dollhouse-i18n';
import { Button, Flex, FlexProps, Tooltip, Typography } from '@spazious/dollhouse-uikit';
import { useEventCallback } from '@spazious/react-hooks';

import { useMetaFields } from '../../hooks/index.js';
import { Features, useFeatures } from '../Features/index.js';

import { CustomMetaFields } from './CustomMetaFields.js';
import { MetaField } from './MetaField.js';

export const DEFAULT_FIELD_PREFIX = 'field-';

export interface InspectorFurnitureProps extends FlexProps {}

export const InspectorFurniture: React.FC<InspectorFurnitureProps> = () => {
  const { actions, metaFieldValues, onChangeField, onAddField, onSubmit } = useMetaFields();
  const { hasFeature } = useFeatures();
  const translate = useTranslate();

  const metaReadOnly = !hasFeature('graphs.setup.node.meta:editable');

  const labelGuest = translate('Guest');
  const labelMenu = translate('Menu');
  const labelAllergies = translate('Allergies');
  const labelNotes = translate('Notes');
  const labelNumbering = translate('Numbering');

  const handleSubmit = useEventCallback(() => {
    onSubmit();
  });

  return (
    <Flex column grow gap="calc(2 * var(--spacing-padding))" justifyContent="space-between">
      <Flex column gap="calc(2 * var(--spacing-padding))">
        <Features features="graphs.setup.node.meta">
          <Flex column grow gap="var(--spacing-gap)">
            <MetaField
              disabled={metaReadOnly}
              field="guest"
              label={labelGuest}
              multiple={false}
              value={metaFieldValues['guest'] ?? ''}
              onChange={onChangeField}
            />
            <MetaField
              disabled={metaReadOnly}
              field="menu"
              label={labelMenu}
              value={metaFieldValues['menu'] ?? ''}
              onChange={onChangeField}
            />
            <MetaField
              disabled={metaReadOnly}
              field="allergies"
              label={labelAllergies}
              value={metaFieldValues['allergies'] ?? ''}
              onChange={onChangeField}
            />
            <MetaField
              disabled={metaReadOnly}
              field="notes"
              label={labelNotes}
              value={metaFieldValues['notes'] ?? ''}
              onChange={onChangeField}
            />
            <MetaField
              disabled={metaReadOnly}
              field="numbering"
              label={labelNumbering}
              value={metaFieldValues['numbering'] ?? ''}
              onChange={onChangeField}
            />
            <CustomMetaFields disabled={metaReadOnly} />
            {!metaReadOnly && (
              <Flex alignItems="center" justifyContent="space-between">
                <Tooltip
                  content={
                    <Typography padding="var(--spacing-padding)" size="medium" variant="label">
                      <Translate>Click to add a custom field</Translate>
                    </Typography>
                  }
                  placement="bottom"
                >
                  <Button
                    color="secondary"
                    disabled={metaReadOnly}
                    size="small"
                    onClick={onAddField}
                  >
                    <Translate>+</Translate>
                  </Button>
                </Tooltip>

                <Button
                  color="primary"
                  disabled={metaReadOnly || !Boolean(actions.current.length)}
                  onClick={handleSubmit}
                >
                  <Translate>Save</Translate>
                </Button>
              </Flex>
            )}
          </Flex>
        </Features>
      </Flex>
    </Flex>
  );
};
